import { EventEmitter } from '@angular/core'

import { SelectiveExceptionHandler } from './selective-exception-handler'
import { DialogComponent, DialogConfiguration } from '../../angular/components/dialog'
import { NoPathsError } from '../../models'
import { DomUtils } from '../../helpers'

export class UiExceptionHandler extends SelectiveExceptionHandler {
  private _dialog: DialogComponent = undefined
  protected _confirmEmitter: EventEmitter<boolean> = new EventEmitter()

  constructor(private _domUtils: DomUtils) { super() }

  public handleError(exception: Error, stackTrace?: any, reason?: string) {
    // TODO [GitHub Issue]: (bug, need to have) Fix google analytics bug |
    // In google analytics, there are two possible paths: one where there is a document path and not. When
    // there is a document path, google analytics runs through code that results in an error. This seems to happen,
    // with a great level of consistency, in safari. However, we have gotten this error in chrome. Here is what we know:
    // When the erroneous path is taken, an XHR request gets created. This has an onReadyStateChange callback that would
    // set the variable holding the request to null (I'm assuming this is for garbage collection reasons). The
    // onReadyStateChange gets called twice for some reason, which means that the second time it is hit, g is null.
    // Then when evaluation g.readyState we get the exception
    if (exception.message.match(/readyState/i) || exception.message.match(/g is null/i)) {
      return
    }

    if (this._dialog instanceof DialogComponent) {
      this._dialog.configure(this._dialogConfigurations())
      this._confirmEmitter.subscribe((confirmed) => this.onConfirm())
      this._dialog.open()
    } else {
      console.error(`${this.constructor.name}: Cannot display error because dialog component is not specified`)
    }
  }

  public setDialog(dialog: DialogComponent) {
    this._dialog = dialog
  }

  public handledErrors(): Array<{new (): Error}> {
    return [Error, NoPathsError]
  }

  protected _dialogConfigurations(): DialogConfiguration {
   return {
      title: 'An unexpected error occurred',
      message: `<p>
      An application error has occurred. Please reload the application to continue.
      If the problem persists feel free to reach out to
      <a href="mailto:techsupport@manhattanprep.com" target="_blank">techsupport@manhattanprep.com</a>.
        </p>`,
      dismissable: false,
      buttons: [
        {
          title: 'Reload app (recommended)',
          emitter: this._confirmEmitter
        }
      ]
    }
  }

  protected onConfirm() {
    this.reloadPage()
  }

  protected onDismiss() {
    this.reloadPage()
  }

  protected reloadPage() {
    this._domUtils.window.location.reload()
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/exception-handlers/ui-exception-handler.ts